<template>
  <div>
    <left-sidebar v-if="noSidebarRoutes.indexOf($route.name) === -1"/>
    <account-modal v-if="accountModal" class="mr-16"></account-modal>
    <v-main class="container-padding  overflow-y-lg-hidden">
      <v-container  :class="[isProfileTab ? 'pa-0' : 'pt-0']" fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <right-sidebar v-if="noSidebarRoutes.indexOf($route.name) === -1"/>
  </div>
</template>

<script>
import RightSidebar from '../components/RightSidebar';
import LeftSidebar from '../components/LeftSidebar';
import AccountModal from '../components/Accounts/AccountModal';
import {mapGetters} from "vuex";

export default {
  name: 'TemplateDefault',
  data: () => ({
    noSidebarRoutes: ['Register', 'Invite', 'Login', 'ForgotPassword', 'NewPassword', 'UpdatePassword', 'Success', 'UpdateForgotPassword']
  }),
  computed: {
    ...mapGetters({"accountModal": "accounts/accountModal"}),
    isProfileTab(){
      return ['operators', 'operator-groups', 'viewOperator', 'operator-groups', 'operator_action', 'addOperator', 'addOperatorGroup', 'viewOperatorGroup', 'editOperator', 'editOperatorGroup', 'resetOperatorCredentials'].includes(this.routeName)
    },
    routeName() {
     return this.$route.name;
   },
  },
  components: {
    LeftSidebar,
    RightSidebar,
    AccountModal
  },
};
</script>

<style>
/* Vuetify vec sam pomakne v-main za sirinu app drawera, pa ovdje ide samo
   unutarnji razmak. Ispod lg stranica mora moci rasti da body preuzme scroll. */
.container-padding {
  padding: 0 16px;
  min-height: 100vh;
}

@media only screen and (min-width: 1264px) {
  .container-padding {
    padding: 0 64px 0 100px;
    height: 100vh;
  }

  .overflow-y-lg-hidden {
    max-height: 100vh;
    overflow-y: hidden;
  }
}

@media only screen and (max-width: 600px) {
  .container-padding {
    padding: 0 !important;
  }
}
</style>
